<div class="button-menu-container">
  <hyperkit-button 
    [variant]="variant" 
    [color]="color" 
    [text]="text"
    [icon]="icon"
    [disabled]="disabled"
    [iconPosition]="iconPosition"
    [size]="size"
    [class.active]="isMenuOpen"
    (click)="toggleMenu($event)">
    <ng-content select="[button-content]"></ng-content>
  </hyperkit-button>
  <hyperkit-dropdown-menu 
    position="absolute"
    [isVisible]="isMenuOpen"
    (closed)="onMenuClosed()">
    <ng-content></ng-content>
  </hyperkit-dropdown-menu>
</div>